import React from "react";
import SmallCard from "../../../components/page/SmallCard";
import Format from "../../../helpers/Format";
import PropTypes from "prop-types";

function FaturamentoCards({ cards, mei }) {
  return (
    <>
      <SmallCard
        title="Faturamento no ano"
        value={Format.formataValor(cards?.valor_total || 0)}
        icon="bx bx-line-chart"
      />
      {!mei ? (
        <>
          <SmallCard
            title="Receita nacional"
            value={Format.formataValor(cards?.receita_nacional || 0)}
            icon="bx bx-money"
          />
          <SmallCard
            title="Receita internacional"
            value={Format.formataValor(cards?.receita_internacional || 0)}
            icon="bx bx-world"
          />
        </>
      ) : (
        <>
          <SmallCard
            title="Valor limite do ano"
            value={Format.formataValor(cards?.valor_limite || 0)}
            icon="bx bx-calendar"
          />
          <SmallCard
            title="Valor permitido no ano"
            value={Format.formataValor(cards?.valor_permitido || 0)}
            icon="bx bx-dollar"
          />
        </>
      )}
    </>
  );
}

FaturamentoCards.propTypes = {
  cards: PropTypes.object.isRequired,
  mei: PropTypes.bool.isRequired,
};

export default FaturamentoCards;
